module.exports = __webpack_public_path__ + "img/dental1_7-8-2021.0442e71a.jpg";